/** In this file entities are declared */
import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../../utils";

const ModuleDefinition = {
  name: "Booking Window",
  entityName: "bookingWindow",
  entities: [],
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section

  translation: {
    translated: false,
    fieldName: "translations",
    displayName: "translations",
    widget: "translations",
    entityProperty: "filterOptionTranslations",
  },
  sorting: {
    property: "filterOptionPosition",
    sortable: false,
  },
  fields: {
    list: [
      {
        fieldName: "startDate",
        displayName: "Start Date",
      },
      {
        fieldName: "endDate",
        displayName: "End Date",
      },
      {
        fieldName: "weekDays",
        displayName: "Days of the week",
      },
      {
        fieldName: "hourRange",
        displayName: "Hour Range",
      },
      {
        fieldName: "timeZone",
        displayName: "Time Zone",
      },
    ],
    form: [
      {
        fieldName: "restrictions",
        widget: "openBooking",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        className: "tickerInput",
      },
    ],
  },
  validation: {},
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
